const ControlRow = ({
  filters,
  setFilters,
  refreshData,
  exportData,
  lastUpdated,
}) => {
  return (
    <div className="bg-gray-800 p-4 rounded-lg shadow mb-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      {/* Search Input */}
      <input
        type="text"
        placeholder="Search address..."
        value={filters.search}
        onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        className="bg-gray-700 text-white px-4 py-2 rounded w-full sm:w-1/3 text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
      />
      {/* Buttons and Last Updated */}
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto items-center">
        <button
          onClick={refreshData}
          className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded text-sm w-full sm:w-auto flex items-center justify-center gap-2 transition duration-200"
        >
          <i className="fas fa-sync-alt"></i> Refresh
        </button>
        <button
          onClick={exportData}
          className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded text-sm w-full sm:w-auto flex items-center justify-center gap-2 transition duration-200"
        >
          <i className="fas fa-download"></i> Export
        </button>
        {lastUpdated && (
          <span className="text-gray-400 text-xs sm:text-sm">
            Last updated: {lastUpdated}
          </span>
        )}
      </div>
    </div>
  );
};

export default ControlRow;
